(function () {
  var overlay, imgEl, prevBtn, nextBtn, closeBtn, counter;
  var images = [];
  var current = 0;

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'lb-overlay';
    overlay.innerHTML =
      '<button class="lb-close" aria-label="Close">&#x2715;</button>' +
      '<button class="lb-arrow lb-prev" aria-label="Previous">&#8592;</button>' +
      '<img class="lb-img" src="" alt="">' +
      '<button class="lb-arrow lb-next" aria-label="Next">&#8594;</button>' +
      '<span class="lb-counter"></span>';

    closeBtn = overlay.querySelector('.lb-close');
    prevBtn  = overlay.querySelector('.lb-prev');
    nextBtn  = overlay.querySelector('.lb-next');
    imgEl    = overlay.querySelector('.lb-img');
    counter  = overlay.querySelector('.lb-counter');

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(current - 1); });
    nextBtn.addEventListener('click', function () { go(current + 1); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.body.appendChild(overlay);
  }

  function show(idx) {
    current = ((idx % images.length) + images.length) % images.length;
    imgEl.src = images[current];
    counter.textContent = (current + 1) + ' / ' + images.length;
  }

  function go(idx) {
    imgEl.classList.add('lb-img--fade');
    setTimeout(function () {
      show(idx);
      imgEl.classList.remove('lb-img--fade');
    }, 150);
  }

  function open(srcs, startIdx) {
    images  = srcs;
    if (!overlay) buildOverlay();
    show(startIdx);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    imgEl.src = '';
  }

  function onKey(e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft')  go(current - 1);
    if (e.key === 'ArrowRight') go(current + 1);
    if (e.key === 'Escape')     close();
  }

  function attachTo(trackSelector) {
    var track = document.querySelector(trackSelector);
    if (!track) return;

    var imgs = Array.from(track.querySelectorAll('img'));
    var half = Math.floor(imgs.length / 2); // unique images, excluding loop dupes
    var srcs = imgs.slice(0, half).map(function (img) { return img.src; });
    if (!srcs.length) return;

    var cards = Array.from(track.querySelectorAll('[class*="__image"]'));

    cards.forEach(function (card, i) {
      // Map duplicate cards back to the original index
      var realIndex = i % srcs.length;
      card.addEventListener('click', function () {
        open(srcs, realIndex);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachTo('.pdp__track');
    attachTo('.pdp-lower__track');
    document.addEventListener('keydown', onKey);
  });
})();
